(() => {
  /**
   * Represents a collection filter for Shopify products.
   */
  class CollectionFilter {
    constructor() {
      this.client = null;
      this.country = window.Shopify.country
        ? window.Shopify.country.toString().toUpperCase()
        : "US";
      this.language = window.Shopify.locale
        ? window.Shopify.locale.toString().toUpperCase()
        : "EN";
      this.default_collections = ["all-coffee", "all-soaps", "all-socks"];
      this.cached_filters = [];
      this.currencies = {
        AED: "د.إ",
        AFN: "؋",
        ALL: "L",
        AMD: "֏",
        ANG: "ƒ",
        AOA: "Kz",
        ARS: "$",
        AUD: "A$",
        AWG: "ƒ",
        AZN: "₼",
        BAM: "KM",
        BBD: "Bds$",
        BDT: "৳",
        BGN: "лв",
        BHD: ".د.ب",
        BIF: "FBu",
        BMD: "BD$",
        BND: "B$",
        BOB: "Bs.",
        BRL: "R$",
        BSD: "B$",
        BTN: "Nu.",
        BWP: "P",
        BYN: "Br",
        BZD: "BZ$",
        CAD: "CA$",
        CDF: "FC",
        CHF: "CHF",
        CLP: "$",
        CNY: "¥",
        COP: "$",
        CRC: "₡",
        CUP: "₱",
        CVE: "$",
        CZK: "Kč",
        DJF: "Fdj",
        DKK: "kr",
        DOP: "RD$",
        DZD: "دج",
        EGP: "E£",
        ERN: "Nfk",
        ETB: "Br",
        EUR: "€",
        FJD: "FJ$",
        FKP: "FK£",
        FOK: "kr",
        GBP: "£",
        GEL: "₾",
        GGP: "£",
        GHS: "GH₵",
        GIP: "£",
        GMD: "D",
        GNF: "FG",
        GTQ: "Q",
        GYD: "GY$",
        HKD: "HK$",
        HNL: "L",
        HRK: "kn",
        HTG: "G",
        HUF: "Ft",
        IDR: "Rp",
        ILS: "₪",
        IMP: "£",
        INR: "₹",
        IQD: "ع.د",
        IRR: "﷼",
        ISK: "kr",
        JEP: "£",
        JMD: "J$",
        JOD: "د.ا",
        JPY: "¥",
        KES: "KSh",
        KGS: "сом",
        KHR: "៛",
        KID: "CI$",
        KMF: "CF",
        KPW: "₩",
        KRW: "₩",
        KWD: "د.ك",
        KYD: "CI$",
        KZT: "₸",
        LAK: "₭",
        LBP: "ل.ل",
        LKR: "රු",
        LRD: "L$",
        LSL: "M",
        LYD: "ل.د",
        MAD: "د.م.",
        MDL: "lei",
        MGA: "Ar",
        MKD: "ден",
        MMK: "K",
        MNT: "₮",
        MOP: "MOP$",
        MRU: "UM",
        MUR: "₨",
        MVR: "Rf",
        MWK: "MK",
        MXN: "$",
        MYR: "RM",
        MZN: "MT",
        NAD: "N$",
        NGN: "₦",
        NIO: "C$",
        NOK: "kr",
        NPR: "रू",
        NZD: "NZ$",
        OMR: "ر.ع.",
        PAB: "B/.",
        PEN: "S/.",
        PGK: "K",
        PHP: "₱",
        PKR: "₨",
        PLN: "zł",
        PYG: "₲",
        QAR: "ر.ق",
        RON: "lei",
        RSD: "дин",
        RUB: "₽",
        RWF: "RF",
        SAR: "ر.س",
        SBD: "SI$",
        SCR: "₨",
        SDG: "ج.س.",
        SEK: "kr",
        SGD: "S$",
        SHP: "£",
        SLL: "Le",
        SOS: "Sh",
        SRD: "$",
        SSP: "£",
        STN: "Db",
        SYP: "£S",
        SZL: "E",
        THB: "฿",
        TJS: "SM",
        TMT: "T",
        TND: "د.ت",
        TOP: "T$",
        TRY: "₺",
        TTD: "TT$",
        TVD: "T$",
        TWD: "NT$",
        TZS: "TSh",
        UAH: "₴",
        UGX: "USh",
        USD: "$",
        UYU: "$",
        UZS: "soʻm",
        VES: "Bs",
        VND: "₫",
        VUV: "VT",
        WST: "WS$",
        XAF: "FCFA",
        XCD: "EC$",
        XDR: "SDR",
        XOF: "CFA",
        XPF: "CFP",
        YER: "﷼",
        ZAR: "R",
        ZMW: "K",
        ZWL: "Z$",
      };

      this.sortMapping = {
        Bestselling: {
          field: "BEST_SELLING",
          reverse: false,
        },
        Newest: {
          field: "CREATED",
          reverse: true,
        },
        "Price, high to low": {
          field: "PRICE",
          reverse: true,
        },
        "Price, low to high": {
          field: "PRICE",
          reverse: false,
        },
        "Alphabetically A-Z": {
          field: "TITLE",
          reverse: false,
        },
        "Alphabetically Z-A": {
          field: "TITLE",
          reverse: true,
        },
        Default: {
          field: "COLLECTION_DEFAULT",
          reverse: false,
          hide: true,
        },
      };

      this.filters = {
        subscription_id: "filter.p.m.custom.recharge_bundle",
        tag_id: "filter.p.tag",
        price_id: "filter.v.price",
      };

      this.tag_filters = {
        badge: "Badge",
        waystosave: "Ways to Save $",
        teatype: "Tea Type",
        producttype: "Product Type",
      };

      this.subtag_filters = {
        style: "Style",
        size: "Size",
        roast: "Roast",
        grind: "Grind",
        caffeine: "Caffeine",
      };

      this.price_filters = {
        15: "Under $15",
        25: "Under $25",
        50: "Under $50",
        100: "Under $100",
      };

      this.#initClient().then((createStorefrontApiClient) => {
        this.client = createStorefrontApiClient.createStorefrontApiClient({
          storeDomain: window.Shopify.shop,
          apiVersion: "2024-01",
          publicAccessToken: "159136723c4a71560f30844a163a1e71",
          customFetchApi: fetch,
        });
        document.dispatchEvent(
          new CustomEvent("Collection:Filter:Ready", {
            detail: { client: this.client },
          })
        );
      });
    }

    /**
     * Initializes the Shopify Storefront API client by dynamically loading the client library.
     *
     * @returns {Promise} A promise that resolves with the ShopifyStorefrontAPIClient object once the library has loaded.
     */
    #initClient() {
      return new Promise((resolve, _reject) => {
        // Create a new script element
        let s = document.createElement("script");

        // Set the source of the script to the URL of the Shopify Storefront API client library
        s.src =
          "https://unpkg.com/@shopify/storefront-api-client@0.2.3/dist/umd/storefront-api-client.min.js";

        // Set the script to load asynchronously
        s.async = true;

        // Set the onload event handler to resolve the promise with the ShopifyStorefrontAPIClient object
        s.onload = () => {
          return resolve(ShopifyStorefrontAPIClient);
        };

        // Insert the script element into the head of the document
        document.head.insertAdjacentElement("beforeend", s);
      });
    }

    /**
     * API BUGS on Products Query
     * To get all the products we can use the endpoint getProducts but the problem is the filters will be empty to get the filters we will get all collections
     * and loop around collections and get products per collection merge the results of filters and products
     * References:
     * https://community.shopify.com/c/hydrogen-headless-and-storefront/storefront-graphql-api-products-filters-is-empty/td-p/1936082
     *
     * @param {String[]} collectionHandles Array of colletcion names by default will use property default_collections
     * @param {String[]} filters Array of selected filters,
     * @param {String[]} subfilters Array of selected subfilters,
     * @param {String} sortKey sortkey eg. Bestselling, Alphabetically A-Z, Alphabetically Z-A, Price, high to low, Price, low to high, Product type, Vendor
     * @param {Boolean} reverse ASC = FALSE or DESC = TRUE
     * @returns {Promise}
     */
    async getMultipleCollectionProducts(
      collectionHandles = [],
      filters = [],
      subfilters = [],
      sortKey = "Default",
      reverse = false,
      afterByHandle = {},
      first = 6,
      filterCache = "use"
    ) {
      let collections = collectionHandles?.length
        ? Array.from(collectionHandles).filter(Boolean)
        : Array.from(this.default_collections);

      let sortMapping = this.sortMapping[sortKey || "Default"];

      let sortKeyParam = sortMapping.field;
      let reverseParam = sortMapping.reverse || reverse;

      let results = await Promise.all(
        collections.map((collection) => {
          let collectionFilter = this.deepCopyArray(filters);
          let subfilteritems = subfilters
            .filter((subfilter) => subfilter.handle === collection)
            .map((subfilter) => subfilter.input);
          if (subfilteritems) {
            collectionFilter = [...filters, ...subfilteritems];
          }
          return this.#_getCollectionProducts(
            collection,
            collectionFilter,
            sortKeyParam,
            reverseParam,
            afterByHandle[collection] || null,
            first
          );
        })
      );

      let availableFilters = this.mergeFilters(results);
      let filtersToDisplay = this.processCachedFilters(availableFilters, filterCache);

      let subFiltersToDisplay = this.deepCopyArray(results).map((result) => {
        let title = result.data.collection.title;
        let handle = result.data.collection.handle;
        return {
          title,
          handle,
          filters: this.deepCopyArray(filtersToDisplay)
            .map((filter) => {
              filter.id = `${handle}.${filter.id}`;
              filter.values = filter.values
                .filter((value) => {
                  if (value.handles) {
                    return value.handles.includes(handle);
                  }
                  return true;
                })
                .map((value) => {
                  value.id = `${handle}.${value.id}`;
                  value.key = `${handle}.${value.key}`;
                  value.param = `${handle}.${value.param}`;
                  value.handle = handle;
                  return value;
                });
              return filter;
            })
            .filter((filter) => filter.values.length > 0),
        };
      });

      let products = results.map((result) => {
        let items = result.data.collection.products.nodes;
        return {
          id: result.data.collection.id,
          title: result.data.collection.title,
          handle: result.data.collection.handle,
          pageInfo: result.data.collection.products.pageInfo,
          products: items.map((p) => this.formatProduct(p)),
        };
      });

      let count = products.reduce((acc, curr) => acc + curr.products.length, 0);
      let totalCount = results.reduce((sum, result) => {
        return sum + this.collectionProductTotal(result);
      }, 0);

      let sortKeys = Object.keys(this.sortMapping).filter(
        (key) => !this.sortMapping[key]?.hide
      );
      document.dispatchEvent(new CustomEvent("Collection:Filter:Change"));
      return {
        filters: filtersToDisplay,
        subfilters: subFiltersToDisplay,
        products,
        sort_keys: sortKeys,
        count,
        totalCount,
      };
    }

    collectionProductTotal(result) {
      const filters = result?.data?.collection?.products?.filters || [];
      const source =
        filters.find((filter) => filter.id === "filter.v.availability") ||
        filters.find((filter) => filter.id === "filter.p.product_type") ||
        filters.find((filter) => filter.id === "filter.p.vendor");
      if (!source?.values?.length) return 0;
      const seen = new Set();
      return source.values.reduce((sum, value) => {
        if (seen.has(value.id)) return sum;
        seen.add(value.id);
        return sum + (Number(value.count) || 0);
      }, 0);
    }

    /**
     * Formats a filter value.
     *
     * @param {Object} filterValue - The filter value to format.
     * @param {string} filterId - The ID of the filter.
     * @returns {Object} The formatted filter value.
     */
    formatFilterValue(filterValue, filterId) {
      let fv = filterValue.id.replace(filterId, "");

      // Format the filter value
      filterValue.value = fv.replace(/^\.+|\.+$/g, "");
      filterValue.key = filterId;
      filterValue.param = `${filterValue.key}=${filterValue.value}`;

      return filterValue;
    }

    /**
     * Handles special formatting for the subscription_id filter.
     *
     * @param {Array} values - The values of the subscription_id filter.
     * @returns {Array} The formatted values.
     */
    handleSubscriptionIdFilter(values) {
      return values.map((value) => {
        if (value.id === "filter.p.m.custom.recharge_bundle.0") {
          value.label = "One Time Purchase";
        }
        if (value.id === "filter.p.m.custom.recharge_bundle.1") {
          value.label = "Subscription";
        }
        return value;
      });
    }

    /**
     * Handles special formatting for the tag_id filter.
     *
     * @param {Array} values - The values of the tag_id filter.
     * @returns {Array} The values that should be grouped.
     */
    handleTagIdFilter(values) {
      let withGroups = [];

      values.forEach((value) => {
        if (value.label.includes("_") && !value.id.includes("itg")) {
          if (value.label.split("_").filter(Boolean).length) {
            withGroups.push(value);
          }
        }
      });

      return withGroups;
    }

    /**
     * Handles special formatting for the price_id filter.
     *
     * @param {Array} values - The values of the price_id filter.
     * @param {Object} priceFilters - The price filters.
     * @returns {Array} The formatted values.
     */
    handlePriceIdFilter(values, priceFilters) {
      return Object.keys(priceFilters).map((key, index) => {
        let filterValue = priceFilters[key];
        return {
          count: 0,
          id: "filter.v.price.lte",
          input: `{"price":{"min":0,"max":${key}}}`,
          key: "filter.v.price.lte",
          label: filterValue,
          param: `filter.v.price.lte=${key}`,
          value: key,
        };
      });
    }

    /**
     * Formats the filters by modifying their values and grouping them by certain properties.
     *
     * @param {Array} filters - The array of filters to format.
     * @returns {Array} The formatted array of filters.
     */
    formatFilters(filters) {
      let withGroups = [];

      // Map over the filters to format their values
      let formatted = [...filters]
        .map((filter) => {
          // Map over the filter values to format them
          filter.values = filter.values.map((filterValue) =>
            this.formatFilterValue(filterValue, filter.id)
          );

          // Special handling for subscription_id filter
          if (filter.id === this.filters.subscription_id) {
            filter.values = this.handleSubscriptionIdFilter(filter.values);
          }

          // Special handling for tag_id filter
          if (filter.id === this.filters.tag_id) {
            withGroups = this.handleTagIdFilter(filter.values);
            return false;
          }

          // Special handling for price_id filter
          if (filter.id === this.filters.price_id) {
            filter.values = this.handlePriceIdFilter(
              filter.values,
              this.price_filters
            );
          }

          return filter;
        })
        .filter(Boolean);

      // Group the filters by label
      let grouped = this.groupObjectsByProperty(withGroups, "label");

      // Format the grouped filters
      Object.keys(grouped).forEach((title) => {
        if (Object.keys(this.tag_filters).includes(title)) {
          let values = this.deepCopyArray(grouped[title]).map((v) => {
            let label = this.removeFirstPartAndUnderscores(v.label);
            v.label = this.capitalizeFirstLetterOfString(label);
            return v;
          });
          let tagFilter = this.tag_filters[title];
          let groupObject = {
            id: values.find((v) => v).key,
            label: this.capitalizeFirstLetterOfString(tagFilter),
            type: "main",
            ref: title,
            values,
          };
          formatted = [groupObject, ...formatted];
        }
        if (Object.keys(this.subtag_filters).includes(title)) {
          let values = this.deepCopyArray(grouped[title]).map((v) => {
            let label = this.removeFirstPartAndUnderscores(v.label);
            v.label = this.capitalizeFirstLetterOfString(label);
            return v;
          });
          let tagFilter = this.subtag_filters[title];
          let groupObject = {
            id: values.find((v) => v).key,
            label: this.capitalizeFirstLetterOfString(tagFilter),
            type: "subtag",
            ref: title,
            values,
          };
          formatted = [groupObject, ...formatted];
        }
      });

      return formatted;
    }

    /**
     * Creates a deep copy of an array. This function uses JSON.stringify to convert the array to a JSON string,
     * and then JSON.parse to convert the string back to a new array. This results in a new array that is a deep copy of the original.
     *
     * @param {Array} arr - The array to copy.
     * @returns {Array} A deep copy of the original array.
     */
    deepCopyArray(arr) {
      // Convert the array to a JSON string
      const jsonString = JSON.stringify(arr);

      // Convert the JSON string back to a new array
      const newArray = JSON.parse(jsonString);

      // Return the new array
      return newArray;
    }

    /**
     * Groups an array of objects by a specified property. The property value is split by underscore and the first part is used as the group key.
     *
     * @param {Array} arr - The array of objects to group.
     * @param {string} property - The property to group the objects by.
     * @returns {Object} The grouped objects.
     */
    groupObjectsByProperty(arr, property) {
      // Initialize an empty object to store the grouped objects
      const grouped = {};

      // Iterate over each object in the array
      arr.forEach((obj) => {
        // Get the first part of the property value by splitting it by underscore
        const key = obj[property].split("_")[0];

        // If the key does not exist in the grouped object, initialize it with an empty array
        if (!grouped[key]) {
          grouped[key] = [];
        }

        // Push the current object into the array for this key
        grouped[key].push(obj);
      });

      // Return the grouped objects
      return grouped;
    }

    /**
     * Capitalizes the first letter of a string.
     *
     * @param {string} str - The string to capitalize.
     * @returns {string} The string with the first letter capitalized.
     */
    capitalizeFirstLetterOfString(str) {
      // Get the first character of the string and convert it to uppercase
      const firstLetter = str.charAt(0).toUpperCase();

      // Get the rest of the string
      const restOfString = str.slice(1);

      // Return the string with the first letter capitalized
      return firstLetter + restOfString;
    }

    /**
     * Removes the first part of a string and all underscores, then joins the remaining parts with spaces.
     *
     * @param {string} str - The string to process.
     * @returns {string} The processed string.
     */
    removeFirstPartAndUnderscores(str) {
      // Split the string into parts by underscore
      const parts = str.split("_");

      // Remove the first part of the array
      const remainingParts = parts.slice(1);

      // Join the remaining parts with spaces and return the result
      return remainingParts.join(" ");
    }

    /**
     * Processes the cached filters. If there are no cached filters, it caches the provided items and formats them.
     * If there are cached filters, it formats them.
     *
     * @param {Array} items - The items to cache and format if there are no cached filters.
     * @returns {Array} The formatted filters.
     */
    processCachedFilters(items, mode = "use") {
      if (mode === "live") {
        return this.formatFilters(this.deepCopyArray(items));
      }
      if (mode === "set") {
        this.cached_filters = this.deepCopyArray(items);
      }
      if (!this.cached_filters.length) {
        return this.formatFilters(this.deepCopyArray(items));
      }
      return this.formatFilters(this.deepCopyArray(this.cached_filters));
    }

    /**
     * Formats an amount object by converting the amount to a fixed decimal format and adding a currency symbol.
     *
     * @param {Object} obj - The amount object to format, containing an amount and a currency code.
     * @returns {Object} The formatted amount object.
     */
    formatAmountObject(obj) {
      // Convert the amount to a fixed decimal format
      let formattedAmount = parseFloat(obj.amount).toFixed(2);

      // Get the currency symbol for the currency code, or use the currency code if no symbol is found
      let currencySymbol =
        this.currencies[obj.currencyCode] || obj.currencyCode;

      // Return the formatted amount object
      return {
        amount: formattedAmount,
        currencyCode: currencySymbol,
      };
    }

    /**
     * Computes the display price for a selling plan adjustment value.
     *
     * @param {number} variantPrice - The one-time variant price.
     * @param {Object} adjustmentValue - The selling plan adjustment value from GraphQL.
     * @returns {{ displayPrice: number, adjustmentType: string }|null}
     */
    getPlanDisplayPrice(variantPrice, adjustmentValue) {
      if (!adjustmentValue) return null;

      if (typeof adjustmentValue.adjustmentPercentage === "number") {
        return {
          displayPrice:
            variantPrice * (1 - adjustmentValue.adjustmentPercentage / 100),
          adjustmentType: "percentage",
        };
      }

      if (adjustmentValue.adjustmentAmount?.amount != null) {
        const amount = parseFloat(adjustmentValue.adjustmentAmount.amount);
        if (Number.isNaN(amount)) return null;
        return {
          displayPrice: variantPrice - amount,
          adjustmentType: "fixed_amount",
        };
      }

      if (adjustmentValue.price?.amount != null) {
        const amount = parseFloat(adjustmentValue.price.amount);
        if (Number.isNaN(amount)) return null;
        return {
          displayPrice: amount,
          adjustmentType: "fixed_price",
        };
      }

      return null;
    }

    /**
     * Finds the selling plan with the lowest display price from a list of items.
     *
     * @param {Array} items - The array of items, each containing selling plans.
     * @param {number|string} variantPrice - The one-time variant price.
     * @returns {Object|null} The best selling plan for display, or null if none qualify.
     */
    findBestSellingPlan(items, variantPrice) {
      if (!items?.length) return null;

      const basePrice = parseFloat(variantPrice);
      if (Number.isNaN(basePrice)) return null;

      return items.reduce((bestPlan, node) => {
        const sellingPlans = node.sellingPlans?.nodes;
        if (!sellingPlans?.length) return bestPlan;

        return sellingPlans.reduce((lowestPlan, plan) => {
          const adjustmentValue = plan.priceAdjustments?.[0]?.adjustmentValue;
          const planPrice = this.getPlanDisplayPrice(basePrice, adjustmentValue);

          if (
            !planPrice ||
            planPrice.displayPrice < 0 ||
            Number.isNaN(planPrice.displayPrice)
          ) {
            return lowestPlan;
          }

          if (
            !lowestPlan ||
            planPrice.displayPrice < lowestPlan.displayPrice
          ) {
            return {
              appName: node.appName,
              name: node.name,
              rechargePlanId: node.options?.[0]?.values?.[0],
              sellingPlanId: plan.id,
              sellingPlanName: plan.name,
              sellingPlanOptions: plan.options.map((option) => ({
                name: option.name,
                value: option.value,
              })),
              checkoutChargeType: plan.checkoutCharge?.type,
              checkoutChargeValue: plan.checkoutCharge?.value?.percentage,
              adjustmentPercentage: adjustmentValue?.adjustmentPercentage,
              adjustmentType: planPrice.adjustmentType,
              displayPrice: planPrice.displayPrice,
              showPlusSuffix: planPrice.adjustmentType === "percentage",
            };
          }

          return lowestPlan;
        }, bestPlan);
      }, null);
    }

    /**
     * Formats a product object by extracting and formatting the necessary fields.
     *
     * @param {Object} product - The product object to format.
     * @returns {Object} The formatted product object.
     */
    formatProduct(product) {
      // Extract and format the necessary fields from the product object
      let id = Number(
        product.id.toString().replace("gid://shopify/Product/", "")
      );
      let title = product.title;
      let handle = product.handle;
      let available = product.availableForSale;
      let compare_at_price = this.formatAmountObject(
        product.compareAtPriceRange.minVariantPrice
      );
      let compare_at_price_min = this.formatAmountObject(
        product.compareAtPriceRange.minVariantPrice
      );
      let compare_at_price_max = this.formatAmountObject(
        product.compareAtPriceRange.maxVariantPrice
      );
      let metafields = product.metafields.filter(Boolean);
      let url = product.onlineStoreUrl;
      let price = this.formatAmountObject(product.priceRange.minVariantPrice);
      let price_min = this.formatAmountObject(
        product.priceRange.minVariantPrice
      );
      let price_max = this.formatAmountObject(
        product.priceRange.maxVariantPrice
      );
      let tags = product.tags.filter(Boolean);
      let type = product.productType;
      let featured_image = product.featuredImage;
      let default_selling_plan = this.findBestSellingPlan(
        product.sellingPlanGroups.nodes,
        price.amount
      );

      // Return the formatted product object
      return {
        id,
        title,
        handle,
        available,
        compare_at_price,
        compare_at_price_min,
        compare_at_price_max,
        metafields,
        url,
        price,
        price_max,
        price_min,
        tags,
        type,
        featured_image,
        default_selling_plan,
      };
    }

    /**
     * Merges products from multiple data sources into a single array.
     *
     * @param {Array} data - The array of data sources, each containing a collection of products.
     * @returns {Array} The combined array of products, each formatted by the formatProduct method.
     */
    mergeProducts(data) {
      // Use the reduce method to combine all products into a single array
      return (
        data
          .reduce((combinedProducts, result) => {
            // Get the products from the current result
            const products = result.data.collection.products.nodes;

            // Iterate over each product
            products.forEach((product) => {
              // Check if the product already exists in the combinedProducts array
              const existingProductIndex = combinedProducts.findIndex(
                (f) => f.id === product.id
              );

              // If the product doesn't exist in the combinedProducts array, add it
              if (existingProductIndex === -1) {
                combinedProducts.push({ ...product });
              }
            });

            // Return the combinedProducts array to be used in the next iteration of reduce
            return combinedProducts;
          }, [])
          // After all products have been combined, map over the array and format each product
          .map(this.formatProduct)
      );
    }

    /**
     * Merges filters from multiple data sources into a single array.
     *
     * @param {Array} data - The array of data sources, each containing a collection of products with filters.
     * @returns {Array} The combined array of filters.
     */
    mergeFilters(data) {
      // Create a new Map to store the combined filters
      const combinedFilters = new Map();

      // Iterate over each result in the data array
      data.forEach((result) => {
        // Get the filters from the result
        const filters = result.data.collection.products.filters;

        // Iterate over each filter
        filters.forEach((filter) => {
          this.processFilter(filter, combinedFilters, result);
        });
      });

      // Convert the combinedFilters Map back to an array and return it
      return Array.from(combinedFilters.values());
    }

    /**
     * Processes a filter.
     *
     * @param {Object} filter - The filter to process.
     * @param {Map} combinedFilters - The combined filters.
     * @param {Object} result - The result containing the filter.
     */
    processFilter(filter, combinedFilters, result) {
      // Check if the filter already exists in the combinedFilters Map
      if (combinedFilters.has(filter.id)) {
        // If it does, get the existing filter
        const existingFilter = combinedFilters.get(filter.id);

        // Iterate over each value in the filter's values array
        filter.values.forEach((value) => {
          this.processValue(value, existingFilter, result);
        });
      } else {
        this.addNewFilter(filter, combinedFilters, result);
      }
    }

    /**
     * Processes a value.
     *
     * @param {Object} value - The value to process.
     * @param {Object} existingFilter - The existing filter.
     * @param {Object} result - The result containing the value.
     */
    processValue(value, existingFilter, result) {
      // Check if the value already exists in the existing filter's values array
      const existingValue = existingFilter.values.find(
        (v) => v.id === value.id
      );

      // If it does, increment the count
      if (existingValue) {
        existingValue.count += value.count;
        existingValue.handles = [
          ...existingValue.handles,
          result.data.collection.handle,
        ];
      } else {
        value.handles = [result.data.collection.handle];
        // If it doesn't, add the value to the existing filter's values array
        existingFilter.values.push(value);
      }
    }

    /**
     * Adds a new filter.
     *
     * @param {Object} filter - The filter to add.
     * @param {Map} combinedFilters - The combined filters.
     * @param {Object} result - The result containing the filter.
     */
    addNewFilter(filter, combinedFilters, result) {
      filter.values = filter.values.map((value) => {
        if (value.handles) {
          value.handles = [...value.handles, result.data.collection.handle];
        } else {
          value.handles = [result.data.collection.handle];
        }
        return value;
      });
      // If the filter doesn't exist in the combinedFilters Map, add it
      combinedFilters.set(filter.id, { ...filter });
    }

    /**
     * @param {String} collectionHandle Collection Handle Name
     * @param {String[]} filters Array of selected filters,
     * @param {String} sortKey sortkey eg. ID PRICE TITLE
     * @param {Boolean} reverse ASC = FALSE or DESC = TRUE
     * @returns {Promise}
     */
    async #_getCollectionProducts(
      collectionHandle,
      filters = [],
      sortKey = "COLLECTION_DEFAULT",
      reverse = false,
      after = null,
      first = 6
    ) {
      let query = `
                query getCollectionByHandle($handle: String!, $filters: [ProductFilter!], $sortKey: ProductCollectionSortKeys!, $reverse: Boolean!, $first: Int!, $after: String) @inContext(country: ${this.country}, language: ${this.language}) {
                    collection(handle: $handle) {
                        id
                        handle
                        title
                        products(first: $first, after: $after, filters: $filters, sortKey: $sortKey, reverse: $reverse) {
                            pageInfo {
                                hasNextPage
                                endCursor
                            }
                            filters {
                                id
                                label
                                type
                                values {
                                    count
                                    id
                                    input
                                    label
                                }
                            }
                            nodes {
                                id
                                title
                                handle
                                availableForSale
                                onlineStoreUrl
                                productType
                                tags
                                featuredImage {
                                    altText
                                    height
                                    id
                                    url
                                    width
                                }
                                priceRange {
                                    maxVariantPrice {
                                        amount
                                        currencyCode
                                    }
                                    minVariantPrice {
                                        amount
                                        currencyCode
                                    }
                                }
                                compareAtPriceRange {
                                    maxVariantPrice {
                                        amount
                                        currencyCode
                                    }
                                    minVariantPrice {
                                        amount
                                        currencyCode
                                    }
                                }
                                featuredImage {
                                    id
                                    altText
                                    height
                                    width
                                    url
                                }
                                metafields (identifiers: [
                                    { namespace: "custom", key: "recharge_bundle" },
                                    { namespace: "bundle", key: "max_count" },
                                    { namespace: "bundle", key: "min_count" },
                                    { namespace: "reviews", key: "rating" },
                                    { namespace: "okendo", key: "summaryData"}
                                ] ) {
                                    id
                                    key
                                    namespace
                                    value
                                    type
                                }
                                sellingPlanGroups (first: 250) {
                                    nodes {
                                        appName
                                        name
                                        options {
                                            name
                                            values
                                        }
                                        sellingPlans (first: 250) {
                                            nodes {
                                                id 
                                                name
                                                options {
                                                    name
                                                    value
                                                }
                                                checkoutCharge {
                                                    type
                                                    value {
                                                        ... on MoneyV2 {
                                                            amount
                                                            currencyCode
                                                        }
                                                        ... on SellingPlanCheckoutChargePercentageValue {
                                                            percentage
                                                        }
                                                    }
                                                }
                                                priceAdjustments {
                                                    adjustmentValue {
                                                        ... on SellingPlanFixedAmountPriceAdjustment {
                                                            adjustmentAmount {
                                                                amount
                                                                currencyCode
                                                            }
                                                        }
                                                        ... on SellingPlanFixedPriceAdjustment {
                                                            price {
                                                                amount
                                                                currencyCode
                                                            }
                                                        }
                                                        ... on SellingPlanPercentagePriceAdjustment {
                                                            adjustmentPercentage
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            `;

      let variables = {
        handle: collectionHandle,
        filters: filters.map((filter) => JSON.parse(filter)),
        sortKey: sortKey ? sortKey : "COLLECTION_DEFAULT",
        reverse: reverse || false,
        first: first || 6,
        after: after || null,
      };

      let { data, _errors, extensions } = await this.client.request(query, {
        variables,
      });

      return { data, extensions };
    }

    async getUniqueProductCount(collectionHandles = [], filters = [], subfilters = []) {
      const collections = Array.from(collectionHandles || []).filter(Boolean);
      const counts = await Promise.all(
        collections.map(async (handle) => {
          let collectionFilter = this.deepCopyArray(filters);
          const subfilteritems = subfilters
            .filter((subfilter) => subfilter.handle === handle)
            .map((subfilter) => subfilter.input);
          if (subfilteritems.length) {
            collectionFilter = [...filters, ...subfilteritems];
          }
          let after = null;
          let hasNext = true;
          let count = 0;
          while (hasNext) {
            const result = await this.#_getCollectionProductIds(
              handle,
              collectionFilter,
              after
            );
            const products = result?.data?.collection?.products;
            const nodes = products?.nodes || [];
            count += nodes.length;
            hasNext = Boolean(products?.pageInfo?.hasNextPage);
            after = products?.pageInfo?.endCursor || null;
            if (!nodes.length) break;
          }
          return count;
        })
      );
      return counts.reduce((sum, count) => sum + count, 0);
    }

    async #_getCollectionProductIds(collectionHandle, filters = [], after = null) {
      const query = `
        query getCollectionProductIds($handle: String!, $filters: [ProductFilter!], $after: String) @inContext(country: ${this.country}, language: ${this.language}) {
          collection(handle: $handle) {
            products(first: 250, after: $after, filters: $filters) {
              pageInfo {
                hasNextPage
                endCursor
              }
              nodes {
                id
              }
            }
          }
        }
      `;
      const { data, extensions } = await this.client.request(query, {
        variables: {
          handle: collectionHandle,
          filters: filters.map((filter) => JSON.parse(filter)),
          after: after || null,
        },
      });
      return { data, extensions };
    }
  }

  window || (window = {});
  window.Collection || (window.Collection = {});
  window.Collection.Filter = new CollectionFilter();

  /**
   * Basic Usage
   *
   * listen for Collection:Filter:Ready before getting collections
   *
   * document.addEventListener('Collection:Filter:Ready', () => {
   *   // window.Collection.Filter.getMultipleCollectionProducts([], [], 'COLLECTION_DEFAULT', true).then(console.log)
   *   // window.Collection.Filter.getMultipleCollectionProducts(['all-coffee'], ['{"available":false}']).then(console.log)
   * });
   */
})();
